<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="d-flex align-items-center">
                    <div class="image-container mr-3">
                        <img src="https://cdn02.plentymarkets.com/s7b04293o1bu/frontend/Ceres_Relaunch/images/service-box-icon-1.svg" alt="Message icon">
                    </div>
                    <div>
                        <p>
                            <strong>{{ headline1 }}: </strong>
                            <a v-if="link1" :href="link1">{{ content1 }}</a>
                            <span v-else>{{ content1 }}</span>
                        </p>
                        <p>
                            <strong>{{ headline2 }}: </strong>
                            <a v-if="link2" :href="link2">{{ content2 }}</a>
                            <span v-else>{{ content2 }}</span>
                        </p>
                        <p>
                            <strong>{{ headline3 }}: </strong>
                            <a v-if="link3" :href="link3">{{ content3 }}</a>
                            <span v-else>{{ content3 }}</span>
                        </p>

                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="d-flex content-wrapper__center">
                    <div class="image-container mr-3">
                        <img src="https://cdn02.plentymarkets.com/s7b04293o1bu/frontend/Ceres_Relaunch/images/service-box-icon-2.png" alt="WhatsApp icon">
                    </div>
                    <div>
                        <p><strong>{{ headline4 }}</strong></p>
                        <p><a :href="link4">{{ content4 }}</a></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 d-flex align-items-center justify-content-end">
                <a :href="buttonLink" class="faq">
                    <span><img src="https://cdn02.plentymarkets.com/s7b04293o1bu/frontend/Ceres_Relaunch/images/question-mark-icon.svg" alt="Question mark icon"></span>
                    <span>{{ buttonText }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            headline1: String,
            headline2: String,
            headline3: String,
            headline4: String,

            content1: String,
            content2: String,
            content3: String,
            content4: String,

            link1: String,
            link2: String,
            link3: String,
            link4: String,

            buttonText: String,
            buttonLink: String
        }
    }
</script>
